import { Box } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import { Text } from "src/shared"

interface TemBoxProps {
  temQuantity: number
}

const TemBox = ({ temQuantity }: TemBoxProps) => {
  return (
    <Box
      width={67}
      sx={{
        [theme.breakpoints.down(600)]: {
          width: 50,
          height: 50,
        },
      }}
      height={70}
      position="relative"
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 67 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.6633 62.7339L13.1708 63.2975L10.1656 52.2368L0.534027 45.9736L4.63312 35.2636L0.534027 24.5536L10.1656 18.2904L13.1708 7.2297L24.6633 7.79338L33.616 0.603271L42.5811 7.79338L54.0737 7.2297L57.0788 18.2904L66.7104 24.5536L62.6114 35.2636L66.7104 45.9736L57.0788 52.2368L54.0737 63.2975L42.5811 62.7339L33.616 69.924L24.6633 62.7339Z"
          fill="#F2E853"
          stroke="#1FA009"
          strokeWidth={2}
        />
      </svg>
      <Box
        sx={{
          [theme.breakpoints.down(600)]: {
            top: 5,
            left: 13,
            "& > p:first-of-type": {
              fontSize: 16,
              lineHeight: "20px",
            },

            "& > p:nth-of-type(2)": {
              fontSize: 11,
              lineHeight: "16px",
            },
          },
        }}
        top={10}
        left={17}
        textAlign="center"
        position="absolute"
      >
        <Text color="#1FA009" fontWeight={700} lineHeight="28px" fontSize={22}>
          {temQuantity}
        </Text>
        <Text color="#1FA009" lineHeight="18px" fontSize={14}>
          TEM
        </Text>
      </Box>
    </Box>
  )
}

export default TemBox
